import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getFillAnalyses, 
  getFillAnalysis, 
  createFillAnalysis,
  clearLocalFillAnalyses,
  clearLocalActiveFillAnalysis 
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } },
  fillAnalysis: { 
    id: '', 
    input: null, 
    result: null, 
    status: '', 
    updated_at: '' },
  loading: { 
    all: false, 
    fillAnalysis: false 
  }
};

const slice = createSlice({
  name: 'fillAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getFillAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getFillAnalyses.fulfilled, (state, action) => {
        const { fill_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...fill_analyses], 'id');

        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getFillAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getFillAnalysis.pending, (state) => {
        state.loading.fillAnalysis = true;
      })
      .addCase(getFillAnalysis.fulfilled, (state, action) => {
        const { data: { fill_analysis }, cable } = action.payload;
        const foundedFillAnalysis = !!_find(state.all.data, (s) => s.id === fill_analysis.id);
        const updatedFillAnalysis = { ...state.fillAnalysis, ...fill_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedFillAnalysis ? _map(state.all.data, (e) => e.id === fill_analysis.id ? { ...e, ...fill_analysis } : e) : [...[fill_analysis], ...oldAllData]; 
        const pagination = foundedFillAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };

        state.loading.fillAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedFillAnalysis && !cable) state.fillAnalysis = updatedFillAnalysis;       
      })
      .addCase(getFillAnalysis.rejected, (state) => {
        state.loading.fillAnalysis = false;
      })
      .addCase(createFillAnalysis.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(createFillAnalysis.fulfilled, (state, action) => {
        const { fill_analysis } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[fill_analysis], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.all = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        state.fillAnalysis = fill_analysis;  
      })
      .addCase(createFillAnalysis.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(clearLocalFillAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveFillAnalysis, state => {
        state.fillAnalysis = initialState.fillAnalysis;
      })
  }
})

export default slice.reducer;